import { Outlet,createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { RouteError } from '@/components/route-error'
import { RoutePending } from '@/components/route-pending'
import { requireAuth } from '@/lib/auth'
import { PrintTemplateType } from '@/types'

const searchSchema = z.object({
  page: z.number().int().min(1).catch(1),
  limit: z.number().int().min(1).catch(20),
  search: z.string().catch(''),
  type: z.nativeEnum(PrintTemplateType).or(z.literal('')).catch(''),
  scope: z.enum(['system', 'organization', 'shop', '']).catch(''),
})

export const Route = createFileRoute('/_dashboard/devices/templates')({
  beforeLoad: requireAuth(),
  validateSearch: searchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TemplatesLayout,
})

function TemplatesLayout() {
  return <Outlet />
}
